import { Box, IconButton } from '@mui/material';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import PercentIcon from '@mui/icons-material/Percent';

interface ToggleDataViewProps {
  isPercent: boolean;
  setIsPercent: (value: boolean) => void;
}

export const ToggleDataView = ({
  isPercent,
  setIsPercent,
}: ToggleDataViewProps) => (
  <Box
    sx={{
      position: 'absolute',
      top: 0,
      right: 0,
      zIndex: 2,
      display: 'flex',
    }}
  >
    <IconButton
      onClick={() => setIsPercent(false)}
      sx={{
        color: !isPercent ? 'primary.main' : 'action.disabled',
        padding: '4px',
      }}
    >
      <AttachMoneyIcon />
    </IconButton>
    <IconButton
      onClick={() => setIsPercent(true)}
      sx={{
        color: isPercent ? 'primary.main' : 'action.disabled',
        padding: '4px',
      }}
    >
      <PercentIcon />
    </IconButton>
  </Box>
);
